module.exports = {
          srcSet: __webpack_public_path__ + "public/images/2b179689fc8d0b2542b0bf0a018fa1d6-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/2b179689fc8d0b2542b0bf0a018fa1d6-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/2b179689fc8d0b2542b0bf0a018fa1d6-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/2b179689fc8d0b2542b0bf0a018fa1d6-1774.webp"},
          
          width: 1774,
          height: 887
        }